<template>
	<q-page-sticky v-if="userIsLoggedIn" position="bottom-right" :offset="[18, 18]" style="z-index: 2">
		<add-new-playlist :show-new-playlist-form="showNewPlaylistForm" :project-id="projectIDs" :user-uuid="userStatus.uuid" :dialog-title="dialogTitle" :dialog-message="dialogMessage" :playlist-title="playlistTitle" :playlist-description="playlistDescription" @close="showNewPlaylistForm = false" />
		<q-fab id="fabBtn" v-model="fabOpen" icon="add" direction="up" color="white" text-color="#0c0c0c">
			<q-fab-action color="white" text-color="#0c0c0c" icon="content_copy" @click="share('playlist', playlist.title, playlist.hash_id)">
				<q-tooltip anchor="center left" self="center right" :offset="[20, 0]">Copy link to playlist</q-tooltip>
			</q-fab-action>
			<q-fab-action v-if="isOwnPlaylist()" color="white" text-color="#0c0c0c" icon="add_to_photos" @click="showAddNewPlaylistModal('duplicate')">
				<q-tooltip anchor="center left" self="center right" :offset="[20, 0]"> Duplicate playlist</q-tooltip>
			</q-fab-action>
			<q-fab-action v-else color="white" text-color="#0c0c0c" icon="bookmark" @click="showAddNewPlaylistModal('copy')">
				<q-tooltip anchor="center left" self="center right" :offset="[20, 0]"> Add to own playlists </q-tooltip>
			</q-fab-action>
			<q-fab-action v-if="isOwnPlaylist()" color="white" text-color="#0c0c0c" icon="edit" @click="editPlaylist(playlist.hash_id)">
				<q-tooltip anchor="center left" self="center right" :offset="[20, 0]"> Edit playlist </q-tooltip>
			</q-fab-action>
		</q-fab>
	</q-page-sticky>
</template>

<script>
	import addNewPlaylist from '../../../cockpit/js/components/global/AddNewPlaylist.vue';

	export default {
		name: 'PlaylistActionsFAB',
		components: { addNewPlaylist },
		props: {
			playlist: {
				type: Object,
				default() {
					return {};
				}
			}
		},

		data() {
			return {
				fabOpen: false,
				showNewPlaylistForm: false,
				projectIDs: [],
				userIsLoggedIn: window.userIsLoggedIn,
				dialogTitle: '',
				dialogMessage: '',
				playlistTitle: '',
				playlistDescription: ''
			};
		},

		computed: {
			userStatus() {
				return this.$store.getters.getUserStatus;
			}
		},

		methods: {
			isOwnPlaylist() {
				return this.playlist.user_uuid === window.user_uuid;
			},

			showAddNewPlaylistModal(mode) {
				var projects = this.getAllProjects();
				// console.log('this.playlist', this.playlist);

				if (mode === 'duplicate') {
					this.dialogTitle = 'Duplicate playlist';
					this.dialogMessage = 'Please fill out the form below to make a duplicate of the current playlist.';
				} else {
					this.dialogTitle = 'Copy playlist';
					this.dialogMessage = 'Please fill out the form below to save a copy of the current playlist to your own playlists.';
				}
				this.projectIDs = projects;
				this.playlistTitle = this.playlist.title;
				this.playlistDescription = this.playlist.description;
				this.showNewPlaylistForm = true;
			},

			share(object, title, id) {
				let fullURL = window.location.origin + '/playlist/' + id;

				if (this.$Clipboard(title + ':\n' + fullURL + '\n')) {
					this.$Swal.fire('Link copied!', `The link to the ` + object + `<br><br><strong>'` + title + `'</strong><br><br>was copied to your clipboard:<br><br><a href="` + fullURL + `" target="_blank" rel="noopener noreferrer" class="link">` + fullURL + `</a>`, 'success');
				} else {
					this.$ToastSwal.fire('Error!', 'The link could not be copied!', 'error');
				}
			},

			getAllProjects() {
				return this.playlist.projects.map(project => {
					return project.id;
				});
			},

			editPlaylist(id) {
				let fullURL = window.location.origin + '/#/playlist/edit/' + id;
				window.Quasar.utils.openURL(fullURL);
			}
		}
	};
</script>
